import { useEffect, useState } from 'react';

const ChatMessages = ({ userId }) => {
  const [threads, setThreads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null); 

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const res = await fetch(`http://localhost:4000/api/messages?userId=${userId}`);  
        if (!res.ok) {
          throw new Error('Failed to fetch messages');
        }
        const data = await res.json();
        setThreads(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, [userId]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;

  return (
    <div style={{ padding: '1rem' }}>
      {threads.map((thread) => (
        <div
          key={thread._id}
          style={{
            border: '1px solid #ddd',
            padding: '1rem',
            borderRadius: '0.5rem',
            marginBottom: '1rem',
          }}
        >
          <h2 style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>
            Chat with {thread.userId}
          </h2>
          <div>
            {thread.messages.map((msg) => (
              <div
                key={msg._id}
                style={{
                  backgroundColor: msg.role === 'user' ? '#dbeafe' : '#f3f4f6',
                  padding: '0.75rem',
                  borderRadius: '0.5rem',
                  marginBottom: '0.5rem',
                }}
              >
                <p style={{ margin: 0 }}>{msg.text}</p>
                <p style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: '0.25rem' }}>
                  {new Date(msg.timestamp).toLocaleString()}
                </p>
              </div>
            ))}
          </div>
        </div>  
      ))}
    </div>
  );
};

export default ChatMessages;
